var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.364 5.636-3.536 3.536zm-3.536 9.192 3.536 3.536zm-5.656-5.656-3.536-3.536zm0 5.656-3.536 3.536zm11.828-2.828c0 1.1819-.2328 2.3522-.6851 3.4442-.4523 1.0919-1.1152 2.084-1.9509 2.9198-.8358.8357-1.8279 1.4986-2.9198 1.9509-1.092.4523-2.2623.6851-3.4442.6851s-2.35222-.2328-3.44415-.6851-2.08408-1.1152-2.91981-1.9509c-.83573-.8358-1.49866-1.8279-1.95096-2.9198-.45229-1.092-.68508-2.2623-.68508-3.4442 0-2.38695.94821-4.67613 2.63604-6.36396s3.97701-2.63604 6.36396-2.63604c2.3869 0 4.6761.94821 6.364 2.63604 1.6878 1.68783 2.636 3.97701 2.636 6.36396zm-5 0c0 1.0609-.4214 2.0783-1.1716 2.8284-.7501.7502-1.7675 1.1716-2.8284 1.1716s-2.07828-.4214-2.82843-1.1716c-.75014-.7501-1.17157-1.7675-1.17157-2.8284s.42143-2.07828 1.17157-2.82843c.75015-.75014 1.76753-1.17157 2.82843-1.17157s2.0783.42143 2.8284 1.17157c.7502.75015 1.1716 1.76753 1.1716 2.82843z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.5f4118dd2db4c959ad9d3e824b7990ad.svg";
export { ForwardRef as ReactComponent };